module.exports = __webpack_public_path__ + "img/new-document.a3008d88.svg";